import { useContext, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { AppBar, Box, Button, Container, Menu, MenuItem, Toolbar } from '@mui/material';
import Logo from '../assets/images/Logo_k2g.svg';
import { UserContext } from '../contexts/user';

const NavBar = () => {

    const {currentUser, setCurrentUser} = useContext(UserContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
      };

    const handleClose= ()=>{
        setAnchorEl(null);
    }

    const handleLogOut = ()=>{
        setCurrentUser(null);
        localStorage.removeItem('userK2G');
        handleClose();
    }

    return (
    <>
        <AppBar sx={{backgroundColor:"white"}} position='static'>
            <Container maxWidth="false">
                <Toolbar disableGutters sx={{justifyContent:"space-between",padding:"10px 0px"}}>
                {
                    /* DESKTOP LOGO */  
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Link to="/">
                            <img src={Logo} className='logoImage' alt='LOGO_KNOW2GROW'/>
                        </Link>
                    </Box>
                }
                {/* {
                    currentUser &&
                    <Button onClick={handleOpenMenu} aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} >
                        PROFILE
                    </Button>
                }
                <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} slotProps={{list: {'aria-labelledby': 'basic-button',sx: {padding: 0}}}}>
                    <MenuItem onClick={handleLogOut} sx={{'&:hover': { backgroundColor: '#0F5385',color:"white"}}}>Log Out</MenuItem>
                </Menu> */}
                {
                    currentUser &&
                    <Button onClick={handleLogOut}>
                        LOG OUT
                    </Button>
                }
                </Toolbar>
            </Container>
        </AppBar>
        <Outlet/>
    </>
    )
}

export default NavBar